import React, { PropsWithChildren } from 'react';

export const ProfileTitle: React.FC<PropsWithChildren<{ tag: 'h1' | 'h2' | 'p'; isSmall?: boolean }>> = ({ children, tag: Tag, isSmall }) => (
  <Tag className={`text-body-primary font-semibold ${isSmall ? 'text-body-secondary' : 'text-title'}`}>{children}</Tag>
);
